module.exports = __webpack_public_path__ + "img/ternate-center-city.a3e784b5.jpg";